import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/sharingFlag/user.sharingFlag.mutation.gql"
import type {
  SetUserSharingFlagMutation,
  SetUserSharingFlagMutationVariables,
} from "@/v2-backoffice-client/user/sharingFlag/__types__/user.sharingFlag.mutation"

type Options = MutationHookOptions<
  SetUserSharingFlagMutation,
  SetUserSharingFlagMutationVariables
>

export function useSetUserSharingFlagMutation(options?: Options) {
  return useMutation<
    SetUserSharingFlagMutation,
    SetUserSharingFlagMutationVariables
  >(mutation, options)
}
